export default function getSocketId(): string {
  // TODO: 보안이슈로 인한, uuid 로직변경필요
  const timestamp: number = +new Date();
  return `${timestamp}${Math.floor(Math.random() * 999)}`;
}
